import React, { Component } from 'react';
import { ModalManager } from 'choerodon-ui/shared';
import Button from '../button';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import { getConfirmLocale } from './locale';
import Dialog from '../rc-components/dialog';
import ConfigContext from '../config-provider/ConfigContext';
export default class Modal extends Component {
    constructor() {
        super(...arguments);
        this.handleCancel = (e) => {
            const { onCancel } = this.props;
            if (onCancel) {
                onCancel(e);
            }
        };
        this.handleOk = (e) => {
            const { onOk } = this.props;
            if (onOk) {
                onOk(e);
            }
        };
        this.renderFooter = (locale) => {
            const { okText, okType, cancelText, confirmLoading, funcType, disableOk, disableCancel, cancelButtonProps, okButtonProps, } = this.props;
            return (React.createElement("div", null,
                React.createElement(Button, Object.assign({ disabled: disableCancel || confirmLoading, onClick: this.handleCancel, funcType: funcType }, cancelButtonProps), cancelText || locale.cancelText),
                React.createElement(Button, Object.assign({ type: okType, funcType: funcType, disabled: disableOk, loading: confirmLoading, onClick: this.handleOk }, okButtonProps), okText || locale.okText)));
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    componentDidMount() {
        ModalManager.registerMousePosition();
    }
    render() {
        const { getPrefixCls, getConfig } = this.context;
        const { footer, visible, prefixCls: customizePrefixCls, movable = getConfig('modalMovable'), center = getConfig('modalAutoCenter'), maskClosable = getConfig('modalMaskClosable'), keyboard = getConfig('modalKeyboard'), } = this.props;
        const prefixCls = getPrefixCls('modal', customizePrefixCls);
        const defaultFooter = (React.createElement(LocaleReceiver, { componentName: "Modal", defaultLocale: getConfirmLocale() }, this.renderFooter));
        return (React.createElement(Dialog, Object.assign({}, this.props, { movable: movable, maskClosable: maskClosable, center: center, keyboard: keyboard, prefixCls: prefixCls, footer: footer === undefined ? defaultFooter : footer, visible: visible, mousePosition: ModalManager.mousePosition, onClose: this.handleCancel })));
    }
}
Modal.displayName = 'Modal';
Modal.defaultProps = {
    width: 520,
    transitionName: 'zoom',
    maskTransitionName: 'fade',
    confirmLoading: false,
    disableOk: false,
    disableCancel: false,
    visible: false,
    okType: 'primary',
    okButtonDisabled: false,
    cancelButtonDisabled: false,
    center: false,
};
